import React, {Component} from 'react';

import {Editor} from '@tinymce/tinymce-react';

export type RichTextEditorProps = {
    value: string;
    editorRef: any;
};

const RichTextEditor: React.FC<RichTextEditorProps> = (props) => {

    const initialValue = (props.value === 'undefined' || props.value === null || props.value === undefined) ? '' : props.value;
    return (
        <Editor onInit={(evt, editor) => props.editorRef.current = editor}
                initialValue={initialValue}
                init={{
                    language: 'zh-Hans',
                    height: 500,
                    menubar: false,
                    toolbar_mode: 'sliding',
                    font_size_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    plugins: 'preview importcss searchreplace autolink autosave save directionality code ' +
                        'visualblocks visualchars fullscreen image link media codesample ' +
                        'table charmap pagebreak nonbreaking anchor insertdatetime ' +
                        'advlist lists charmap quickbars formatpainter',

                    toolbar: 'undo redo | bold italic underline strikethrough | ' +
                        'fontfamily fontsize blocks formatpainter | ' +
                        'alignleft aligncenter alignright alignjustify | outdent indent | table numlist bullist | forecolor backcolor removeformat' +
                        ' | fullscreen  preview code | image media link codesample ',

                    content_style: 'body { font-family:黑体,宋体,sans-serif; font-size:12pt }',
                    extended_valid_elements: "iframe[src|width|height|name|align]",
                    font_family_formats: "宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
                    // setup: function (editor) { //设置默认字体样式
                    //     editor.on('init', function (e) {
                    //         // this.getBody().style.fontSize = '12pt';
                    //         this.getBody().style.color = '#000';
                    //         // this.getBody().style.fontFamily = '黑体';
                    //     });
                    // },
                }}
        />
    );
}

export default RichTextEditor;